export enum NavbarAccessDeniedReason {
    None = 0,
    MissingLicense = 1,
    SubscriptionDisabled = 2,
    DevelopFeatureDisabled = 3
}

export interface NavbarAccess {
    canAccessEvaluate: boolean;
    canAccessTrack: boolean;
    canAccessDevelop: boolean;
    evaluateDeniedReason: NavbarAccessDeniedReason;
    trackDeniedReason: NavbarAccessDeniedReason;
    developDeniedReason: NavbarAccessDeniedReason;
}
